import type { AppConnectionBannerState } from './types';

export const initialState: AppConnectionBannerState = {
	unconnectedApps: [],
	isVisible: false,
	forceMultiline: false,
	showConnectedState: false,
};
